module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/1200_630_yumomi-c273d9f0feecde2960adef5bd1c7defd.jpg";